import { defineMessages } from 'react-intl';

const messages = defineMessages({
  progressBarTitle: {
    id: 'frontbucket.repository.pullRequest.reviewedProgressBar.title',
    description: 'Progress bar title',
    defaultMessage: '{fileCount} files viewed',
  },
  progressBarFileCount: {
    id: 'frontbucket.repository.pullRequest.reviewedProgressBar.fileCount',
    description: 'Progress bar file count',
    defaultMessage: '{numFilesViewed} of {numTotalFiles}',
  },
});

export default messages;
